/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { hideModal, show, format, isEmpty, getConfig, arrayFrom, showModal, openWindow } from '../../twd'
import {css, jsx} from '@emotion/core'

const listCss = css `
    div {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    dt, dd {
        padding: 6px;
        line-height: 1.4;
        font-weight:400;
        color: #242424;
        border-bottom: 1px solid #e4e4e4;
        white-space: nowrap;
    }
    dt {
        text-align: left;
    }
    dd {
        text-align: right;
        font-weight: 500;
    }
`
const offerCss = css `
    dt, dd {
        white-space: nowrap;
        margin: 0;
        font-weight:400;
        line-height: 1.4;
    }
    dt {
        padding: 6px;
        padding-top: 0px;
    }
    dd {
        padding: 6px;
        padding-top: 0px;
        font-weight:500;
        border-bottom: 1px solid #e4e4e4;
    }
    div {
        display: grid;
        grid-template-columns: 1fr;
    }
`

export const Detail = ({
    holdIssue,
    holdCusip,
    holdCoupon,
    holdCorpSector,
    holdInvType,
    holdSpInd,
    holdUseOfProceeds,
    askPrice,
    askQuantity,
    askYield,
    askYieldmat,
    moodyRating,
    spRating,
    firstCouponDate,
    nextCouponDate,
    datedDate,
    research,
    showBackLink,
    showTradeHistory,
    showBondDetail,
    isTreasuryAuction,
    from
}) => {
    const entryDetail = holdInvType==='C' ? {label:'Sector', value:holdCorpSector}
        : holdInvType==='M' ? {label:'Purpose', value:holdUseOfProceeds}
        : {}

    const hasOffer = !isEmpty(askPrice)
        || !isEmpty(askQuantity)
        || !isEmpty(askYield)
        || !isEmpty(askYieldmat)

    const prospectus = arrayFrom(research)
        .filter(a => a.type==='legal' || a.type==='sales')
        .map(({url}) => {

            url = String(url)
            .replace("BDResearch.showViewer('", "")
		    .replace("');", '')

            return url
                ? getConfig('bw_service_host') + url
                : ''
        })[0]

    const isTradeHistoryLink = showTradeHistory==='Y' && ['A','C','M'].indexOf(holdInvType)>=0
    const isBondDetailLink = !isTreasuryAuction && (!isTradeHistoryLink || showBondDetail==='Y')

    return <div className='bond-issuer' data-name="bond-issuer-tooltip">
        <h3 className="text-bold text-truncate" style={{ maxWidth:'300px'}}>{holdIssue}</h3>

        { hasOffer && <div className="row">
        <dl css={offerCss}>
            <div className="col-md-3" style={{paddingRight:0}}>
                <dt>Price</dt>
                <dd>{format.price(askPrice,format.empty())}</dd>
            </div>
            <div className="col-md-3" style={{paddingRight:0, paddingLeft:0}}>
                <dt>Qty Available</dt>
                <dd>{format.count(askQuantity,format.empty())}</dd>
            </div>
            <div className="col-md-3 text-right" style={{paddingRight:0, paddingLeft:0}}>
                <dt>YTM</dt>
                <dd>{format.ytw(askYieldmat,'',format.empty())}</dd>
            </div>
            <div className="col-md-3 text-right" style={{paddingLeft:0}}>
                <dt>YTW</dt>
                <dd>{format.ytw(askYield,'',format.empty())}</dd>
            </div>
        </dl></div>}

        <div className="row vertical-offset-sm">
        <dl css={listCss}>
            <div className="col-md-6" style={{paddingRight:0}}>
            <dt>CUSIP</dt>
            <dd>{holdCusip}</dd>
            <dt>Type</dt>
            <dd>{INV_TYPES[holdInvType] || format.empty()}</dd>
                <dt>{entryDetail.label || format.empty()}</dt>
                <dd>{entryDetail.value || format.empty()}</dd>
            <dt>Moody/S&amp;P</dt>
            <dd>{moodyRating || format.empty()} / {spRating || format.empty()}</dd>
            </div>

            <div className="col-md-6" style={{paddingLeft:0}}>
            <dt>Coupon</dt>
            <dd>{isTreasuryAuction ? format.empty() : format.cpn(holdCoupon)}</dd>
            <dt>First Coupon</dt>
            <dd>{firstCouponDate || format.empty()}</dd>
            <dt>Next Coupon</dt>
            <dd>{nextCouponDate || format.empty()}</dd>
            <dt>Dated</dt>
            <dd>{datedDate || format.empty()}</dd>
            </div>
        </dl></div>

        <div className="row">
            <div className="col-md-5 text-nowrap">
            {prospectus &&
                <button
                    data-name="prospectus-offering-document-link"
                    className="btn-link"
                    onClick={() => { openWindow(prospectus, "_blank") }}
                >Prospectus / Offering Document</button>
            }
            </div>
            <div className="col-md-7 text-right text-nowrap">
            {isBondDetailLink ? <button
                data-name="bond-detail-link"
                className="btn-link"
                onClick={() => {
                    hideModal()
                    show("bond-detail", {
                        cusip:holdCusip,
                        showBackLink,
                        from,
                    })
                }}
                >Bond detail</button>
            :null}

            {isBondDetailLink && isTradeHistoryLink
                && <span aria-hidden="true" style={{width:'10px', display:'inline-block'}}>&nbsp; &nbsp;</span>}

            {isTradeHistoryLink ? <button
                data-name="trade-history-link"
                className="btn-link"
                onClick={(e) => {
                    showModal({
                        view: 'trade-history',
                        cusip: holdCusip,
                        source: e.target,
                    })
                }}
                >Trade history</button>
            : null}
            </div>
        </div>
        </div>
}


const INV_TYPES = {
    'A': 'Agencies',
    'R': 'Pass-Throughs',
    'K': 'Asset-Backed',
    'S': 'CDs',
    'O': 'CMOs',
    'C': 'Corporates',
    'M': 'Municipals',
    'P': 'Preferreds',
    'L': 'Structured Products',
    'T': 'U.S. Treasuries',
}
